import { JobSearchQuery } from '@/utils/route-utils';

const NURSE_API_ID = 'nurse';
const DEFAULT_JOB_COVER_IMAGE =
  'https://s3.amazonaws.com/nomadhealth/5db1fb075830de00da264d24/349a14eb13236a992fb90b23a0504a48.png';

const DEFAULT_JOB_SEARCH_QUERY: JobSearchQuery = {
  ordering: 'highest_pay',
  compactState: false,
};

const NOMAD_API_CONSTANTS = Object.freeze({
  NURSE_API_ID,
  DEFAULT_JOB_COVER_IMAGE,
  DEFAULT_JOB_SEARCH_QUERY,
});

export default NOMAD_API_CONSTANTS;
